module.exports = __webpack_public_path__ + "img/keturah.46564e90.png";